import Vue from 'vue'
import configs from '@/config'

const { publicLanggraphApiUrl, ahaaiv2Url } = configs

export const AI_INSIGHTS_TIMEOUT_MS = 45000
export const hasAiInsightsV2 = Boolean(ahaaiv2Url)

let resource = null

export const actions = {
  getInsights: {
    method: 'GET',
    url: `${ahaaiv2Url}/api/ai-v2/report-insight/presentation/{presentationId}/session/{sessionId}/`,
    timeout: AI_INSIGHTS_TIMEOUT_MS,
  },
  getInsightsLegacy: {
    method: 'GET',
    url: `${publicLanggraphApiUrl}/api/report-insight/presentation/{presentationId}/session/{sessionId}/`,
    timeout: AI_INSIGHTS_TIMEOUT_MS,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getInsights = async ({
  presentationId, sessionId, useV2, source,
}) => {
  const action = useV2 ? resource.getInsights : resource.getInsightsLegacy
  const params = { presentationId, sessionId }
  // Only the v2 report-insight endpoint has a Postgres-DW twin; the legacy
  // langgraph endpoint does not, so never send ?source there.
  if (useV2 && source) params.source = source
  const res = await action(params)
  return res.body
}

export default {
  initResource,
  getInsights,
}
